import { api } from "src/shared/setup/API/api";

interface IEventAbandonment {
  event:
    | "PRESENTATION"
    | "PLANS"
    | "CHECKOUT"
    | "CHECKOUT_SUCCESS"
    | "CHECKOUT_FAILED";
}

export const UseFormAbandonment = () => {
  const handleCreate = async ({ event }: IEventAbandonment) => {
    return api.post("/abandonment", { event }).then().catch();
  };

  return { handleSubmit: handleCreate };
};
